export default __webpack_public_path__ + "static/img/panelArt_dark.f37f2c21.svg";